module.exports = __webpack_public_path__ + "static/img/min3.0211c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/agent/min3.png
// module id = vFma
// module chunks = 1